import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Placement } from 'react-bootstrap/types'

interface Props {
  tooltip: string
  placement?: Placement
  children: React.ReactElement
}

export default function ElementWithTooltip({
  tooltip,
  placement = 'bottom',
  children,
}: Props) {
  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 250, hide: 400 }}
      overlay={(overlayProps) => (
        <Tooltip id="element-tooltip" {...overlayProps}>
          {tooltip}
        </Tooltip>
      )}
    >
      {children}
    </OverlayTrigger>
  )
}
